import { render, staticRenderFns } from "./CustomButtonRadio.vue?vue&type=template&id=2524d29e"
import script from "./CustomButtonRadio.vue?vue&type=script&lang=js"
export * from "./CustomButtonRadio.vue?vue&type=script&lang=js"
import style0 from "./CustomButtonRadio.vue?vue&type=style&index=0&id=2524d29e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports